export default {
    initCollapsible() {
        let triggers = document.querySelectorAll(".js-collapsible-trigger");

        triggers.forEach(trigger => {
            trigger.addEventListener("mouseup", event => {

                trigger.closest(".js-collapsible").classList.toggle("is-open");

                if (trigger.getAttribute("aria-expanded") === "true") {
                    console.log('aria true');
                    trigger.setAttribute("aria-expanded", "false");
                } else {
                    trigger.setAttribute("aria-expanded", "true");
                }

                event.preventDefault();
            });
        });
    }
};
